import styled from '@emotion/styled';

const Wrapper = styled('div')(
  {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    fontSize: 16,
    fontWeight: 400
  },
  ({ theme }) => ({
    color: theme.palette.colors.midnightBlue
  })
);

export default Wrapper;
